// Threadheads Update: Keep a useful server-rendered snapshot if the public review API is unavailable.
(() => {
  const refreshRatings = async (root) => {
    if (!root || root.dataset.ratingsRequested) return;
    root.dataset.ratingsRequested = 'true';
    try {
      const response = await fetch('https://api.okendo.io/v1/stores/678d2f3b-80ca-4900-ba42-a1d9be42ee02/review_aggregate', {
        credentials: 'omit',
        signal: AbortSignal.timeout(5000),
      });
      if (!response.ok) return;
      const { reviewAggregate: aggregate } = await response.json();
      const count = aggregate?.reviewCount;
      const total = aggregate?.reviewRatingValuesTotal;
      const fiveStars = aggregate?.reviewCountByLevel?.level5Count;
      if (!Number.isFinite(count) || count <= 0 || !Number.isFinite(total)) return;
      const rating = total / count;
      if (rating < 1 || rating > 5) return;
      const score = rating.toFixed(1);
      root.querySelector('[data-th-onsite-rating]').textContent = score;
      root.querySelector('[data-th-onsite-count]').textContent = count.toLocaleString('en');
      const stars = root.querySelector('[data-th-onsite-stars] .th-reviews-stars');
      stars.style.setProperty('--star-fill', `${Number(score) * 20}%`);
      stars.setAttribute('aria-label', `${score} out of 5 stars`);
      root.querySelector('[data-th-onsite-date]').textContent = 'checked today';
      if (Number.isFinite(fiveStars) && fiveStars >= 1000 && fiveStars <= count) {
        root.querySelector('[data-th-five-star-count]').textContent = `${(Math.floor(fiveStars / 1000) * 1000).toLocaleString('en')}+`;
      }
    } catch {
      // Blocked third-party requests should never remove the readable rating snapshot.
    }
  };
  document.querySelectorAll('[data-th-reviews]').forEach(refreshRatings);
  document.addEventListener('shopify:section:load', (event) => refreshRatings(event.target.querySelector('[data-th-reviews]')));
})();
